import { useCallback } from 'react';
import { apiService } from '@services/api';

export interface PhaseOption {
  ConversationPhaseId: number;
  Title: string;
  Name?: string;
}

export interface CardOption {
  value: number;
  label: string;
  projectName: string;
  conversationTitle: string;
  phases?: PhaseOption[];
}

export function useCardSearch()
{
  const loadCards = useCallback(async (inputValue: string): Promise<CardOption[]> =>
  {
    try
    {
      const searchText = inputValue.trim();

      const response = await apiService.post<any>(
        'conversation/GetConversationsBySearchFilter',
        {
          SearchText: searchText,
          Filters: '',
          PageNumber: 1,
          PageSize: 30,
        },
      );

      const conversations = response?.Conversations || response?.conversations || response;

      if (!Array.isArray(conversations))
      {
        console.warn('[useCardSearch] Invalid response structure:', Object.keys(response || {}));
        return [];
      }

      return conversations.map((conv: any) => ({
        value: conv.ConversationId,
        label: `(${conv.ProjectName || 'No project'}) ${conv.Title}`,
        projectName: conv.ProjectName || 'No project',
        conversationTitle: conv.Title,
        phases: conv.Phases || [],
      }));
    }
    catch (error)
    {
      console.error('[useCardSearch] Error loading cards:', error);
      return [];
    }
  }, []);

  return { loadCards };
}
